import { useRouteError, isRouteErrorResponse } from 'react-router';

const RootBoundary = () => {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        console.warn('ROUTER ERROR');

        if (error.status === 404) {
            console.warn('ROUTER | PAGE NOT FOUND');
        }
    }

    return null;
};

export default RootBoundary;
